import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { Role, RoleQueryParams, DataUpdatePermission } from "../types";

interface RoleState {
  roleList: Array<Role>;
  roleTotal: number;
  roleDetail: Role;
}

export const roleDefault: Role = {
	id: 0,
	name: "",
	description: "",
	status: true,
};

const initialState: RoleState = {
	roleList: [],
	roleDetail: roleDefault,
	roleTotal: 0,
};

export const roleSlice = createSlice({
	name: "role",
	initialState,
	reducers: {
		setListRole: (state, action) => {
			state.roleList = action.payload.data;
			state.roleTotal = action.payload.total;
		},
		setDetailRole: (state, action) => {
			state.roleDetail = action.payload.data;
		},
		resetDetailRole: (state) => {
			state.roleDetail = roleDefault;
		},
		deleteRole: (state, action) => {
			const { id } = action.payload;
			state.roleList = state.roleList.filter(el => el.id !== id);
		},
		changeStatusRole: (state, action) => {
			const { id, status } = action.payload;
			const index = state.roleList.findIndex(el => el.id === id);
			state.roleList[index].status = status;
		},
	},
});

export const selectRoleList = (state: RootState) => state.role.roleList;
export const selectRoleTotal = (state: RootState) => state.role.roleTotal;
export const selectRoleDetail = (state: RootState) => state.role.roleDetail;

export const { setListRole, setDetailRole, deleteRole, changeStatusRole, resetDetailRole } =
  roleSlice.actions;

export interface GetListRoleAsyncPayload {
  query: RoleQueryParams;
}
export const getListRoleAsync = createAction(
	"role/getListRoleAsync",
	(payload: GetListRoleAsyncPayload) => ({
		payload: payload,
	}),
);

export interface GetDetailRoleAsyncPayload {
  id: number;
}
export const getDetailRoleAsync = createAction(
	"role/getDetailRoleAsync",
	(payload: GetDetailRoleAsyncPayload) => ({
		payload,
	}),
);

export interface DeleteRoleAsyncPayload {
  id: number;
}
export const deleteRoleAsync = createAction(
	"role/deleteRoleAsync",
	(payload: DeleteRoleAsyncPayload) => ({
		payload,
	}),
);

export interface CreateRoleAsyncPayload {
  bodyParams: Role;
	callback?: () => void;
}
export const createRoleAsync = createAction(
	"role/createRoleAsync",
	(payload: CreateRoleAsyncPayload) => ({
		payload,
	}),
);

export interface UpdateRoleAsyncPayload {
  data: Role;
  id: number;
	callback?: () => void;
}
export const updateRoleAsync = createAction(
	"role/updateRoleAsync",
	(payload: UpdateRoleAsyncPayload) => ({
		payload,
	}),
);

export interface UpdateRolePermissionAsyncPayload {
  bodyParams: DataUpdatePermission[];
}
export const updateRolePermissionAsync = createAction(
	"role/updateRolePermission",
	(payload: UpdateRolePermissionAsyncPayload) => ({
		payload,
	}),
);

export default roleSlice.reducer;
